/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { IDiagLabInventory } from 'app/shared/model/diag-lab-inventory.model';
import { IDiaglabBill } from 'app/shared/model/diaglab-bill.model';
import { IDiagLabInventoryCheckout } from 'app/shared/model/diag-lab-inventory-checkout.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface IDiagLabInventoryInvestigation {
  id?: string;
  consumedUses?: number | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  consumedById?: string | null;
  consumedByType?: keyof typeof AddedByType | null;
  diagLab?: IDiagLab | null;
  type?: IDiagLabInventory | null;
  diaglabBill?: IDiaglabBill | null;
  checkout?: IDiagLabInventoryCheckout | null;
}

export const defaultValue: Readonly<IDiagLabInventoryInvestigation> = {
  active: false,
};
